import { apiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BaseResource";
class CustomerGroupResource extends BaseCamelCasedResource {
    pk() {
        return this.customerId?.toString() || "";
    }
}
CustomerGroupResource.urlRoot = apiResourceUrl("customer-group");
export { CustomerGroupResource };
//# sourceMappingURL=CustomerGroupResource.js.map